module.exports = __webpack_public_path__ + "static/media/ilbc4.11ba9917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ilbc4.jpg
// module id = 5802
// module chunks = 0